// Configuración de la Base de Datos
export const DB_NAME = "GeoDB";
export const DB_VERSION = 5;
export const STORE_NAME = "posiciones";